import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7254dc0e")

_pushScopeId("data-v-7254dc0e")
const _hoisted_1 = { class: "user__content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "Nom: ", -1)
const _hoisted_3 = { class: "user__attr" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Email: ", -1)
const _hoisted_5 = { class: "user__attr" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Role: ", -1)
const _hoisted_7 = {
  key: 1,
  class: "user__attr"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Teams: ", -1)
const _hoisted_9 = {
  key: 0,
  class: "perm__teams perm__teams--edit"
}
const _hoisted_10 = { class: "perm__teams--noedit" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "icon-cancel" }, null, -1)
const _hoisted_12 = { class: "team-name" }
const _hoisted_13 = {
  key: 1,
  class: "perm__teams perm__teams--noedit"
}
const _hoisted_14 = { class: "user__attr" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("div", {
    class: ["user__item", {'selected': _ctx.editMode}]
  }, [
    _createVNode("img", { src: _ctx.userImg }, null, 8, ["src"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _hoisted_2,
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.user.name), 1)
      ]),
      _createVNode("div", null, [
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.user.email), 1)
      ]),
      _createVNode("div", null, [
        _hoisted_6,
        (_ctx.editMode && _ctx.canEditRole)
          ? _withDirectives((_openBlock(), _createBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.role = $event))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userRoles, (rolename) => {
                return (_openBlock(), _createBlock("option", { key: rolename }, _toDisplayString(rolename), 1))
              }), 128))
            ], 512)), [
              [_vModelSelect, _ctx.role]
            ])
          : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.user.role), 1))
      ]),
      _createVNode("div", null, [
        _hoisted_8,
        (_ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teams, (team, ix) => {
                  return (_openBlock(), _createBlock("div", {
                    key: ix,
                    class: "team-name",
                    onClick: ($event: any) => (_ctx.removeTeam(team))
                  }, [
                    _createVNode(_component_TeamLabel, {
                      team: _ctx.teamInfo(team),
                      link: false
                    }, null, 8, ["team"]),
                    _hoisted_11
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_12, [
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.teams[_ctx.teams.length] = $event))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableTeams, (team, ix) => {
                    return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.teams[_ctx.teams.length]]
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_13, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.teams, (team, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: idx,
                  class: "team-name"
                }, [
                  _createVNode("span", _hoisted_14, [
                    _createVNode(_component_TeamLabel, {
                      team: _ctx.teamInfo(team)
                    }, null, 8, ["team"])
                  ])
                ]))
              }), 128))
            ]))
      ]),
      (_ctx.editMode)
        ? (_openBlock(), _createBlock("i", {
            key: 0,
            class: "icon-upload",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.editUserEvent && _ctx.editUserEvent(...args)))
          }))
        : (!_ctx.editMode && _ctx.canEdit)
          ? (_openBlock(), _createBlock("i", {
              key: 1,
              class: "icon-sketch",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editMode = true))
            }))
          : (!_ctx.editMode && _ctx.canConfirm)
            ? (_openBlock(), _createBlock("i", {
                key: 2,
                class: "icon-select2",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmUserEvent && _ctx.confirmUserEvent(...args)))
              }))
            : _createCommentVNode("", true),
      (_ctx.editMode)
        ? (_openBlock(), _createBlock("i", {
            key: 3,
            class: "icon-cancel-circled",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelEdits && _ctx.cancelEdits(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.canDelete && !_ctx.editMode)
        ? (_openBlock(), _createBlock(_component_ConfirmAction, {
            key: 4,
            type: "delete",
            class: "delete__trig",
            onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('user-delete', _ctx.user._id)))
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
})